import ralColors from "../colors/ralColorsFactory";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";
import "./ralColorPropertyEditor.css";

type Props = {
    label: string;
    /**
     * Color string in `RAL 9001` format as currently used in DE
     *
     * @see {@link ralColors}
     */
    ralColor: string;

    /**
     * Currently editing is not supported
     */
    disabled: true;
};

export const RalColorPropertyEditor = ({ label, ralColor }: Props) => {
    const currentColorHex = ralColors.getColor(ralColor);
    return (
        <PropertyEditor title={label} className="ral-color-selector-container">
            <div className="ral-color-preview-wrapper">
                <div
                    className="ral-color-circle ral-color-preview-circle"
                    style={{ backgroundColor: currentColorHex }}
                    title={ralColor}
                />
            </div>
            <div className="ral-color-display">{ralColor}</div>
        </PropertyEditor>
    );
};
